import { useTranslation } from 'react-i18next';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';

export default function PlaceholderPage({ titleKey }) {
  const { t } = useTranslation();
  return (
    <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
      <Paper elevation={0} variant="outlined" sx={{ p: 6 }}>
        <ConstructionOutlinedIcon sx={{ fontSize: 56, color: 'primary.light', mb: 2 }} />
        <Typography variant="h6" fontWeight={700} gutterBottom>
          {t(titleKey)}
        </Typography>
        <Typography color="text.secondary">Coming soon on web</Typography>
      </Paper>
    </Container>
  );
}
